import { render, staticRenderFns } from "./BdoProgress.vue?vue&type=template&id=b37839f0&scoped=true"
import script from "./BdoProgress.vue?vue&type=script&lang=js"
export * from "./BdoProgress.vue?vue&type=script&lang=js"
import style0 from "./BdoProgress.vue?vue&type=style&index=0&id=b37839f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37839f0",
  null
  
)

export default component.exports